import { useContext, useMemo } from 'react';

import { UseOpenCloseReturn } from '~/core/hooks/useOpenClose';
import { useEquifaxPpsrGrantorSearchForm } from '~/core/shared/api/plugin';
import { EMPTY_ARR } from '~/core/shared/constants';
import { Option } from '~/core/shared/types/utility';
import { ApplicationContext } from '../../../../../Layout.component';
import { grantorToSelectOption } from '../../logic';

export const useGrantorOptions = (
  modalApi: UseOpenCloseReturn,
): Option<string>[] => {
  const { applicationUuid } = useContext(ApplicationContext);
  const { formData } = useEquifaxPpsrGrantorSearchForm(applicationUuid, {
    enabled: modalApi.open,
  });
  const grantorOptions = useMemo(
    () =>
      formData?.grantors?.map(grantorToSelectOption) ??
      (EMPTY_ARR as Option<string>[]),
    [formData?.grantors],
  );

  return grantorOptions;
};
